import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";

export default function CaseStudies() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/case-studies").then((r) => setList(r.data)); }, []);

  return (
    <div data-testid="cases-page" className="pt-24">
      <section className="container mx-auto px-4 pt-16 pb-12">
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF007F] mb-3">Case Studies</div>
        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none mb-6 max-w-4xl">
          Real numbers. <span className="text-gradient-animate">Real growth.</span>
        </h1>
      </section>

      <section className="container mx-auto px-4 pb-24 grid lg:grid-cols-2 gap-6">
        {list.map((c, i) => (
          <Link to={`/case-studies/${c.slug}`} key={c.id} data-testid={`case-${c.slug}`}
            className={`group relative overflow-hidden rounded-2xl ${i === 0 ? "lg:col-span-2 aspect-[2/1]" : "aspect-[16/10]"}`}>
            <img src={c.cover} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
            <div className="absolute bottom-0 left-0 p-7 text-white">
              <div className="text-[10px] font-mono uppercase tracking-widest text-[#00BFE0] mb-2">{c.industry}</div>
              <h3 className="font-display font-black text-2xl sm:text-3xl mb-3 max-w-2xl">{c.title}</h3>
              <div className="flex flex-wrap gap-4 mb-4">
                {c.results.map((r) => (
                  <div key={r.metric}>
                    <div className="font-display font-black text-2xl text-gradient-animate">{r.value}</div>
                    <div className="text-[10px] uppercase tracking-widest text-white/60">{r.metric}</div>
                  </div>
                ))}
              </div>
              <span className="inline-flex items-center gap-1 text-sm font-semibold">Read case study <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" /></span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
